import { Services } from '~/gql/graphql'

export type ServiceIconType = 'phone' | 'tv' | 'wifi'

const WIFI_ICON = 'wifi'
const PHONE_ICON = 'phone'
const TV_ICON = 'tv'

const generateIcons = (services: Services) => {
  const icons: ServiceIconType[] = []

  if (services.broadband) {
    icons.push(WIFI_ICON)
  }

  if (services.telephone && services.telephone.inclusiveCalls !== 'none') {
    icons.push(PHONE_ICON)
  }

  if (services.tv) {
    icons.push(TV_ICON)
  }

  return icons
}

export default generateIcons
